/*eslint-disable */
import React, { Component } from "react";
import { Image, Grid } from "semantic-ui-react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { faFileInvoice } from "@fortawesome/free-solid-svg-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-theme-material.css";

import moment from 'moment';
import allAxiosCommonTA from "../../components/axiosComponent/allAxiosCommonTA";
import TitleBar from "./titleBar";
import ClubInvoice from './clubInvoice';
import DemapInvoice from './demapInvoice';
import {consigneeConsignorCheck ,DD_MM_yyyy} from '../../utils/constant'
import {invoiceColumnHeaders} from '../../utils/componentColumnConstants'
import InvoiceActions from "./invoiceActions";

class Invoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      searchValue: '',
      selectedRows: [],
      isLoading: false
    };
  }

  componentDidMount() {
    // this.props.read();
    this.getAllInvoice()
  }

  getAllInvoice = () => {
    allAxiosCommonTA({ url: `/deliveries/invoices`, method: "get" })
      .then((response) => {
        this.setState({ rowData: response.data.data, isLoading: true });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  handleSearch = (e) => {
    this.setState({ searchValue: e.target.value });
  }

  handleSelect = (data) => {
    let selectedrows = data.api.getSelectedRows();
    if (selectedrows.length !== this.state.selectedRows.length) {
      this.setState({ selectedRows: selectedrows });
    }
  }

  getEditDetails = (data) => {
    this.props.history.push({ pathname: "/add-ewaybill", state: data });
  };

  onGridReady = (prams) => {
    // console.log("ag grid is read ", prams);
    this.gridApi = prams.api;
    this.setState({
      isLoading: this.props.isLoading,
    });
    prams.columnApi.autoSizeAllColumns('', false);
    this.gridColumnApi = prams.columnApi;
    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds);
    // this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    // if (this.props.sizeColumnsToFit) prams.api.sizeColumnsToFit();
  }

  render() {
    var columnDefs = [
      /* {
        sideBar: {
          toolPanels: [
            {
              id: "columns",
              labelDefault: "Columns",
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
            },
            {
              id: "filters",
              labelDefault: "Filters",
              labelKey: "filters",
              iconKey: "filter",
              toolPanel: "agFiltersToolPanel",
            },
          ],
          defaultToolPanel: "",
        }
      }, */

      {
        headerName: invoiceColumnHeaders.invoice_no,
        field: "invoice_no",
        sortable: true,
        filter: true,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: (params) => {
          // console.log("CHECK CHEKC CHECK CHECKLLLLLL")
          // console.log(params?.data?.delivery?.order?.allotment_status)
          if (params?.data?.delivery?.order?.allotment_status?.allotment_code == "ALLOC" ||
            consigneeConsignorCheck(localStorage.getItem("role")))
            return false
          else
            return true
        },
        cellClass: params => {
          return (params?.data?.delivery?.order?.allotment_status?.allotment_code == "ALLOC") ? 'padding-left-40' : 'padding-left-0';
        },
        tooltipField: "invoice_no",
        enableRowGroup: true,
        enablePivot: true,
        suppressSizeToFit: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: invoiceColumnHeaders.invoice_reference_no ,
        field: "invoice_reference_no",
        tooltipField: "invoice_reference_no",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: invoiceColumnHeaders.delivery_reference_no ,
        field: "delivery.delivery_reference_no",
        tooltipField: "delivery_reference_no",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: invoiceColumnHeaders.order_reference_no ,
        field: "delivery.order.order_reference_no",
        tooltipField: "order_reference_no",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: invoiceColumnHeaders.invoice_date,
        field: "invoice_date",
        tooltipField: "invoice_date",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format(DD_MM_yyyy)
            : "Na";
        },
      },
      {
        headerName: invoiceColumnHeaders.invoice_amount,
        field: "invoice_amount",
        tooltipField: "invoice_amount",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: invoiceColumnHeaders.invoice_qunatity,
        field: "invoice_quantity",
        tooltipField: "invoice_quantity",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: invoiceColumnHeaders.status,
        field: "invoice_status",
        tooltipField: "invoice_status",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: invoiceColumnHeaders.actions,
        field:"create_eway_bill",
        cellRenderer: "InvoiceActions",
        suppressToolPanel: true,
        pinned: "right",
        suppressSizeToFit: true,
      },

    ];

    var frameworkcomponent = {
      InvoiceActions:InvoiceActions
    }

    let rowItems = []

    if (this.state.rowData) {
      this.state.rowData.map((o, i) => {
        let temp = {}
        let delivery_reference_no = { delivery_reference_no: "NA" }
        let order_reference_no = { order_reference_no: "NA" }

        temp = o;
        if (temp?.delivery)
          temp.delivery.delivery_reference_no = o?.delivery?.delivery_reference_no || "NA"
        if (temp?.delivery?.order)
          temp.delivery.order.order_reference_no = o?.delivery?.order.order_reference_no || "NA"
        temp.invoice_no = o?.invoice_no || "NA"
        temp.invoice_date = o?.invoice_date ? o.invoice_date : "NA"
        temp.invoice_amount = o?.invoice_amount || "NA"
        temp.invoice_quantity = o?.invoice_quantity || "NA"
        temp.invoice_status = o?.delivery?.order?.allotment_status?.allotment_text || "NA"
        rowItems[i] = temp
      })
    }

    return (
      <React.Fragment>
        <div className="page-title-invoice">
          <TitleBar
            title="Invoice" handleSearch={this.handleSearch}></TitleBar>

        </div>

        <div className="ag-theme-material agOver dispatch_bar" style={this.state?.selectedRows?.length > 0 ?
          { marginBottom: "50px", } :
          {}
        }>
          <AgGridReact
            suppressSizeToFit={true}
            domLayout="autoHeight"
            sideBar={this.state.sideBar}
            debounceVerticalScrollbar={true}
            rowGroupPanelShow={"always"}
            rowSelection="multiple"
            style={{ width: '100%', height: '50%' }}
            loadingOverlayComponent={this.state.loadingData}
            reactUi="true"
            animateRows="true"
            columnDefs={columnDefs}
            enableRangeSelection="true"
            rowData={rowItems}
            suppressRowClickSelection="true"
            quickFilterText={this.state.searchValue}
            pagination={true}
            paginationPageSize={10}
            onSelectionChanged={this.handleSelect}
            resizable="true"
            onGridReady={this.onGridReady}
            frameworkComponents={frameworkcomponent}
            getEditDetails={this.getEditDetails}
          />
        </div>

        <>
          {this.state.selectedRows.length > 0 &&
            !consigneeConsignorCheck(localStorage.getItem("role")) ? (

            <div className="life-cycle w3-white p-2">
              <Grid columns={2} className="ml-2">
                <Grid.Row>
                  <ClubInvoice
                    invoices={this.state.selectedRows}
                  ></ClubInvoice>
                  <DemapInvoice
                    invoices={this.state.selectedRows}
                  ></DemapInvoice>
                </Grid.Row>
              </Grid>
            </div>
          ) : null}
        </>
      </React.Fragment>
    );
  }
}


export default Invoice;